module.exports = __webpack_public_path__ + "static/img/8.744239f.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/internetimg/8.png
// module id = mmxQ
// module chunks = 9